import { addPendo } from '@ecoonline/pendo-integration'

export default {
  install (app) {
    const { ecoonline } = window
    const { pendo: pendoData, initialData, env } = ecoonline ?? {}
    const { enabled, key: pendoKey } = pendoData ?? {}
    const { name, emailAddress, platformAdminAccess, ecoIdCompany, language } = initialData ?? {}
    if (!enabled || !pendoKey) return

    try {
      addPendo({
        productIdentifier: 'platform',
        production: env === 'p' && !/stage/.test(window.location.hostname),
        apiKey: pendoKey,
        userData: {
          email: emailAddress,
          role: platformAdminAccess ? 'Admin' : 'Non-admin',
          fullName: name,
          crm: ecoIdCompany?.crm,
          companyName: ecoIdCompany?.name,
          accountType: ecoIdCompany?.type,
          language
        }
      })
    } catch (e) {
      app.config.globalProperties.$exception(e)
    }
  }
}
